import { Box, Text } from '@chakra-ui/react'
import PercorsiComp from '../components/PercorsiComp'
import TopBarPercorso from '../components/TopBarPercorso'

const Percorsi = () => {
    return (
        <Box display='flex' alignItems='center' flexDirection='column' w='100%' bgGradient={[
            'linear(to-b, gray.300, green.300, gray.200)'
        ]}>
            <TopBarPercorso />
            <PercorsiComp />
            <Text fontWeight='extrabold' textDecor='underline' textColor='white' my={2}>Pwd by Jacopo Berlingieri 2022 </Text>
        </Box>

    )
}

export default Percorsi